'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var TrackingEventDescription = require('./TrackingEventDescription.js');
var TrackingEventsList_module = require('./TrackingEventsList.module.css.js');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const TrackingEvents = ({
  history,
  collapsed
}) => {
  const {
    bodytextDefaultNone,
    smalltextDefaultNone,
    smalltextEmphasisNone
  } = nthHookTheme.useTheme();
  const historyGroupedByDate = history.reduce((acc, event) => {
    const {
      dateFormatted: [date]
    } = event;
    const eventList = acc.get(date);
    if (eventList) {
      eventList.push(event);
    } else {
      acc.set(date, [event]);
    }
    return acc;
  }, new Map());
  return /*#__PURE__*/React__default["default"].createElement("ol", {
    className: TrackingEventsList_module["default"].orderedList,
    "data-test": "shippingHistoryEventsContainer"
  }, [...historyGroupedByDate.entries()].map(([date, eventList], idx) => /*#__PURE__*/React__default["default"].createElement("li", {
    key: date,
    style: {
      marginTop: idx && '1.5rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: clsx.clsx({
      [TrackingEventsList_module["default"].dateExpanded]: !collapsed,
      [TrackingEventsList_module["default"].dateCollapsed]: collapsed
    }),
    style: smalltextEmphasisNone
  }, /*#__PURE__*/React__default["default"].createElement("time", null, date)), /*#__PURE__*/React__default["default"].createElement("ol", {
    className: TrackingEventsList_module["default"].orderedList
  }, eventList.map(({
    description,
    formattedDescription,
    city,
    state,
    dateFormatted: [, time]
  }) => {
    const timeAndLocation = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("time", null, time), time && (city || state) && /*#__PURE__*/React__default["default"].createElement("span", {
      "aria-hidden": "true"
    }, "\xA0|\xA0"), /*#__PURE__*/React__default["default"].createElement("span", null, city, city && state && ', ', state));
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: `${date}${time}${city ?? ''}${state ?? ''}${description ?? ''}`,
      className: TrackingEventsList_module["default"].orderedListItem
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: clsx.clsx({
        [TrackingEventsList_module["default"].dateLocationExpanded]: !collapsed,
        [TrackingEventsList_module["default"].dateLocationCollapsed]: collapsed
      }),
      style: smalltextDefaultNone
    }, timeAndLocation), /*#__PURE__*/React__default["default"].createElement(TrackingEventDescription["default"], {
      formattedDescription: formattedDescription,
      description: description,
      s: bodytextDefaultNone
    }));
  })))));
};
var TrackingEventsList = nthHookTheme.withThemeProvider(TrackingEvents, {
  themeTokens: ['bodytextDefaultNone', 'smalltextDefaultNone', 'smalltextEmphasisNone']
});

exports["default"] = TrackingEventsList;
